"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "ICO-CIRCULAR-MOVISTAR-PLUS",
    transform: "translate(0 -1396)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Grupo_7569",
      "data-name": "Grupo 7569",
      transform: "translate(5.556 1409.5)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Grupo_6121",
        "data-name": "Grupo 6121",
        transform: "translate(22.89 2.385)",
        opacity: "0.65",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          id: "Grupo_6120",
          "data-name": "Grupo 6120",
          transform: "translate(0 0)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            id: "Grupo_6119",
            "data-name": "Grupo 6119",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              id: "Trazado_5921",
              "data-name": "Trazado 5921",
              d: "M700.591,268.909a.176.176,0,0,0,.177.175H702.3a.176.176,0,0,0,.177-.175v-3.275h3.3a.177.177,0,0,0,.177-.176v-1.52a.177.177,0,0,0-.177-.175h-5.185Z",
              transform: "translate(-699.383 -262.698)",
              fill: "#fff"
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        id: "Trazado_5922",
        "data-name": "Trazado 5922",
        d: "M680.044,238.027a.177.177,0,0,0-.177-.176h-1.532a.177.177,0,0,0-.177.176V241.3h-3.3a.176.176,0,0,0-.177.175V243a.177.177,0,0,0,.177.176h5.185Z",
        transform: "translate(-654.061 -237.851)",
        fill: "#fff"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        id: "Trazado_5923",
        "data-name": "Trazado 5923",
        d: "M524.651,239.5c-.9.015-2.564.456-3.323,3.534a10.427,10.427,0,0,0-.175,4.4,16.746,16.746,0,0,0,1.036,3.591,3.194,3.194,0,0,0,.4.676,1.089,1.089,0,0,0,1.245.308c.282-.138.607-.472.49-1.231a9.99,9.99,0,0,0-.313-1.2,13.183,13.183,0,0,1-.692-2.81c-.043-1.054.375-1.192.653-1.252.467-.1.859.407,1.231,1.046.444.761,1.206,2.112,1.827,3.143a3.559,3.559,0,0,0,3.258,1.859,3.5,3.5,0,0,0,3.586-2.731,33.2,33.2,0,0,1,1.338-3.8c.607-1.33,1.417-2.042,2.1-1.824.633.2.791.816.8,1.719a20.323,20.323,0,0,1-.159,2.327,6.685,6.685,0,0,0-.055.969,1.065,1.065,0,0,0,.848,1.112,1.293,1.293,0,0,0,1.322-1,5.446,5.446,0,0,0,.183-.851,15.194,15.194,0,0,0,.148-3.48,12.375,12.375,0,0,0-.933-4.172,2.884,2.884,0,0,0-2.372-1.978,3.475,3.475,0,0,0-3.186,2.17c-.643,1.365-1.158,2.766-1.47,3.481a1.816,1.816,0,0,1-1.5,1.248,2.441,2.441,0,0,1-2.18-1.438,20.671,20.671,0,0,0-1.945-2.775,2.756,2.756,0,0,0-2.167-1.042",
        transform: "translate(-520.997 -237.855)",
        fill: "#fff"
      })]
    })
  })
});

var MovistarPlus = function MovistarPlus(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "MovistarPlus-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '5.2 5 30 30';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = MovistarPlus;
exports["default"] = _default;

//# sourceMappingURL=index.js.map